/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Anton Kalachev <anton.kalachev@opensoftdev.com>
 */

import 'APP_THEME/_common/vip_level_popup/vip_level_popup.less';

import SelfClosedPopup from 'assets/js/modules/popup/SelfClosedPopup';
import Popup from 'assets/js/modules/popup/PopupLight';
import router from 'assets/js/common/router/index';
import screen from 'assets/js/modules/screen';

$(function() {
    const vipPopup = new SelfClosedPopup(new Popup($('#vip-popup:not(.mobile)'), { width: 400 }));

    $('.account').on('click', '.vip-level-star', function(e) {
        e.preventDefault();
        const vipLevel = $(this).data('vip-level');
        if (vipLevel === '') {
            return;
        }

        if (screen.isXs()) {
            window.location.href = router.generate('/account/profile/vip');
        } else {
            vipPopup.open(20000);
        }
    });
});
